import { observer } from "mobx-react";
import { DROPDOWN_MENU_WIDTH, IOption, SelectDropdown } from "../../../../../../../../../components/inputs/select-dropdown/select-dropdown";
import { ICompareValueTypeComponentProps } from "../condition-field";
import ReturnReasonCompareValueStore from "../../../../../../../stores/compare-value/return-reason-compare-value-store";

const ReturnReasonCompareValueField: React.FC<ICompareValueTypeComponentProps> = observer(({store, condition, operatorSelector}) => {
    const compareValueStore: ReturnReasonCompareValueStore = store as ReturnReasonCompareValueStore;

    const options = compareValueStore.returnReasonOptions as IOption[];
    const selectedOption = options.find(o => o.value === compareValueStore.value);

    return (
        <>
            {operatorSelector} 

            <SelectDropdown disabled={!condition.isEditMode} value={selectedOption} options={options} onChange={e => compareValueStore.setValue(e?.value as number)}
                menuWidth={DROPDOWN_MENU_WIDTH.MAX_CONTENT} />      
        </>
    );
});

export default ReturnReasonCompareValueField;